import {
  TransactionAccountsSearchRequest,
  TransactionClientsSearchRequest,
  TransactionDetailResponse,
  TransactionDropdownSearchResponse,
  TransactionFinalStatus,
  TransactionIdsSelectRequest,
  TransactionsCommonDropdownsResponse,
  TransactionsListResponse,
  TransactionsQuery,
  TransactionsExportResponse,
} from "src/entities/transactions/model/types";
import api from "src/shared/api";

export const transactionsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getTransactionsList: build.query<
      TransactionsListResponse,
      TransactionsQuery
    >({
      query: (body) => ({
        url: "/api/transactions",
        method: "POST",
        body,
      }),
    }),
    getTransactionDetail: build.query<TransactionDetailResponse, string>({
      query: (transactionId) => ({
        url: `/api/transactions/${transactionId}`,
        method: "GET",
      }),
    }),
    closeTransaction: build.mutation<void, string>({
      query: (transactionId) => ({
        url: `/api/transactions/${transactionId}/close`,
        method: "POST",
      }),
    }),
    setTransactionFinalStatus: build.mutation<
      void,
      { transactionId: string; status: TransactionFinalStatus }
    >({
      query: ({ transactionId, status }) => ({
        url: `/api/transactions/${transactionId}/final-status`,
        method: "POST",
        body: { status },
      }),
    }),
    getTransactionsCommonDropdowns: build.query<
      TransactionsCommonDropdownsResponse,
      void
    >({
      query: () => ({
        url: "/api/dropdowns/transactions/common",
        method: "GET",
      }),
    }),
    searchTransactionClients: build.mutation<
      TransactionDropdownSearchResponse,
      TransactionClientsSearchRequest
    >({
      query: (body) => ({
        url: "/api/dropdowns/transactions/clients",
        method: "POST",
        body,
      }),
    }),

    searchTransactionAccounts: build.mutation<
      TransactionDropdownSearchResponse,
      TransactionAccountsSearchRequest
    >({
      query: (body) => ({
        url: "/api/dropdowns/transactions/accounts",
        method: "POST",
        body,
      }),
    }),
    getTransactionClientsByIds: build.mutation<
      TransactionDropdownSearchResponse,
      TransactionIdsSelectRequest
    >({
      query: (body) => ({
        url: "/api/dropdowns/transactions/clients-for-select",
        method: "POST",
        body,
      }),
    }),

    getTransactionAccountsByIds: build.mutation<
      TransactionDropdownSearchResponse,
      TransactionIdsSelectRequest
    >({
      query: (body) => ({
        url: "/api/dropdowns/transactions/accounts-for-select",
        method: "POST",
        body,
      }),
    }),
    getTransactionFirstDate: build.query<{ date: string }, void>({
      query: () => ({
        url: "/api/dropdowns/transactions/first-transaction-date",
      }),
    }),
    exportTransaction: build.mutation<
      TransactionsExportResponse,
      TransactionsQuery
    >({
      query: (body) => ({
        url: "/api/transactions/export",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useGetTransactionsListQuery,
  useGetTransactionDetailQuery,
  useCloseTransactionMutation,
  useSetTransactionFinalStatusMutation,
  useGetTransactionsCommonDropdownsQuery,
  useSearchTransactionAccountsMutation,
  useSearchTransactionClientsMutation,
  useGetTransactionClientsByIdsMutation,
  useGetTransactionAccountsByIdsMutation,
  useGetTransactionFirstDateQuery,
  useExportTransactionMutation,
} = transactionsApi;
